import React from 'react'
import { NavLink } from 'react-router-dom';

const Navbar = () => {
    return (
    

        <div className='container-fluid'>
            <div className='row p-2'>
                {/* <div className='col-10 mx-auto'> */}
                    <nav className="navbar navbar-expand-lg navbar-light bg-light">
                        <div className="container-fluid">

                            <NavLink to="/"><i class="fa-brands fa-grav"></i><span className='logo'>     GravIty AcaDemy</span></NavLink>
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">

                            <div className='menu_bar'>

                         
                                <ul className="navbar-nav ml-2 mb-2 mb-lg-0">
                                    <li className="nav-item">
                                        <NavLink to="/">Home</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/About">About</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/Contact">Contact</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/Servises">Servises</NavLink>
                                    </li>
                                </ul>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        // </div>
    )
}

export default Navbar;